import { useEffect, useRef } from 'react';

import { LIST_MAX_HEIGHT, LIST_MIN_HEIGHT } from './SavedListsModal.constants';

interface UseSavedListsBodyHeightProps {
  deps?: any[];
  modalBodyRef: React.RefObject<HTMLDivElement>;
  toolbarRef?: React.RefObject<HTMLDivElement>;
}

export const useSavedListsBodyHeight = ({
  deps = [],
  modalBodyRef,
  toolbarRef,
}: UseSavedListsBodyHeightProps) => {
  const heightRef = useRef<number>(LIST_MAX_HEIGHT);

  // This was in the original modal, assuming it's there to modify the list height to avoid double scrollbars, this will only exec when opened, not on resize
  useEffect(() => {
    if (modalBodyRef.current) {
      const bodyScrollHeight = modalBodyRef.current.scrollHeight;
      const bodyHeight = modalBodyRef.current.clientHeight;
      const toolbarHeight = toolbarRef?.current?.clientHeight || 0;
      const paddingHeight = 12 + 24;
      const newHeight = bodyHeight - toolbarHeight - paddingHeight;
      const minBodyHeight =
        bodyHeight < LIST_MIN_HEIGHT + toolbarHeight + paddingHeight
          ? bodyHeight
          : LIST_MIN_HEIGHT + toolbarHeight + paddingHeight;
      if (newHeight < LIST_MAX_HEIGHT && bodyHeight < bodyScrollHeight) {
        heightRef.current =
          newHeight < minBodyHeight ? minBodyHeight : newHeight;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deps]);

  return heightRef;
};
